"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Страницы «Мои вакансии», просмотр вакансии, отклики, форма публикации вакансии */
const auctionHowItWorksButtonClick = ({ vacancyId, campaignDraftId, campaignId, campaignStatus, campaignCreationStatus, ...analyticsParams }) => analytics_js_1.default.sendHHEventButtonClick("auction_how_it_works_modal_open", { vacancyId, campaignDraftId, campaignId, campaignStatus, campaignCreationStatus, ...analyticsParams });
exports.default = auctionHowItWorksButtonClick;
